import { DEFAULT_COLUMN_WIDTH, pxToChars } from "../../utils/excelToFortuneSheet";

/** One Excel column per weekday. */
export const WEEK_COLUMN_COUNT = 7;

/** Fixed header block: title, department, date range, generation stamp, weekday names. */
export const TITLE_ROW = 1;
export const DEPARTMENT_ROW = 2;
export const SUBTITLE_ROW = 3;
export const GENERATED_ROW = 4;
export const WEEKDAY_HEADER_ROW = 5;
/** Week blocks start on the row after the header block. */
export const FIRST_BLOCK_ROW = 6;

/** Repeat the title + weekday header on every printed page. */
export const PRINT_TITLES_ROW = `${TITLE_ROW}:${WEEKDAY_HEADER_ROW}`;

/** Shown on a day with nothing on it, mirroring the on-screen cell. A glyph, not prose — not translated. */
export const EMPTY_DAY_PLACEHOLDER = "--";

/**
 * Column width in Excel character units. Matches the spreadsheet preview's own default column
 * width so an undragged column measures the same in the preview and in the downloaded file.
 */
export const DEFAULT_WEEK_COLUMN_WIDTH = pxToChars(DEFAULT_COLUMN_WIDTH);

/**
 * Hard ceiling on generated rows. A profile with years of history can reach several hundred weeks,
 * and both the spreadsheet preview and the PDF renderer degrade badly past that. Exceeding it is
 * surfaced as an error rather than silently truncating the schedule.
 */
export const MAX_EXPORT_ROWS = 4000;

export const TITLE_FONT_SIZE = 16;
export const DEPARTMENT_FONT_SIZE = 12;
export const SUBTITLE_FONT_SIZE = 11;
/** The generation stamp is provenance, not content — it sits quietly under the range. */
export const GENERATED_FONT_SIZE = 9;
export const DATE_ROW_FONT_SIZE = 10;
export const ENTRY_FONT_SIZE = 10;

/**
 * Points of row height per line of cell text. Matches Excel's own default single-line row height,
 * which leaves a little breathing room above and below `ENTRY_FONT_SIZE` text.
 *
 * Entry rows are sized explicitly instead of relying on auto-fit: a shift cell stacks its time,
 * location and job on separate lines, and neither the spreadsheet preview nor a narrow printed
 * column will reveal lines the row height doesn't reserve.
 */
export const ENTRY_LINE_HEIGHT_PT = 15;
